module.exports = __webpack_public_path__ + "img/atex_zone_1.9dacd7e0.png";